<template>
  <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
             :visible.sync="detailVisible" width="70%" title="采购订单详情" :before-close="detailClose">
    <div class="add-box-account" v-loading="loading">
      <div class="table-box">
        <div class="img-box">
          <img :src="detail.product.image" alt="" v-if="detail.product"/>
        </div>
        <table class="custom-table" border="1">
          <tr>
            <td>CAS号</td>
            <td>{{ detail.cas_no }}</td>
            <td>产品名称</td>
            <td>{{ detail.product_name }}</td>
          </tr>
          <tr>
            <td>需求量</td>
            <td>{{ detail.number }} {{ detail.unit }}</td>
            <td>是否接受定制</td>
            <td>{{ detail.is_quotes == 1 ? "是" : "否" }}</td>
          </tr>
          <tr>
            <td>询单有效期</td>
            <td>{{ detail.begin_at }} ~ {{ detail.end_at }}</td>
            <td>寄往地区</td>
            <td>
              {{ detail.province }}{{ detail.city }}{{ detail.district }}
            </td>
          </tr>
          <tr>
            <td>期望价格</td>
            <td>{{ detail.expected_price }}</td>
            <td>发票类型</td>
            <td>
              {{
                detail.invoice_type == 1 ? "增值税专用发票" : "增值税普通发票"
              }}
            </td>
          </tr>
          <tr></tr>
        </table>
      </div>
      <div>
        <div class="table-title">
          <div>
            <span class="title-text">报价列表 ({{ cas_no_quoteList.length }}条)</span>
            <span v-if="userInfo.vip_status != 1"><span class="color-red">*</span> <el-button @click="getVip" type="text">成为vip</el-button>  可直接查看报价方联系方式自主交易~</span>
            <span v-if="userInfo.vip_status == 1"><span class="color-red">*</span> 尊贵的 {{ userInfo.member_type == 2 ? "SVIP用户" : "VIP用户" }} 您可以联系报价方自主对接交易~</span>
          </div>
          <div>
            <el-button type="primary" plain size="mini" @click="contactBusiness">联系业务</el-button>
          </div>
        </div>
        <el-table :data="cas_no_quoteList" max-height="250" border :header-cell-style="{ backgroundColor: '#D1E1FB' }"
                  v-if="cas_no_quoteList.length > 0">
          <el-table-column type="index" label="序号" width="50" fixed="left">
          </el-table-column>
          <el-table-column prop="people.company" label="报价方">
            <template slot-scope="scope">
                            <div v-if="userInfo.vip_status == 1">
                              {{ scope.row.people.company }}

                              <template v-if="scope.row.people">
                                <el-tag type="primary" size="mini" v-if="scope.row.people.member_type==1">
                                  VIP用户
                                </el-tag>
                                <el-tag type="success" size="mini" v-if="scope.row.people.member_type==2">
                                  SVIP用户
                                </el-tag>
                              </template>
                            </div>
<!--                          @click="getVip(scope.row)"   -->
              <el-button type="text" @click="getVip" v-else>******</el-button>
            </template>
          </el-table-column>
          <el-table-column v-if="userInfo.vip_status == 1" prop="people.mobile" label="联系方式"
                           width="120"></el-table-column>
          <el-table-column prop="value" label="数量" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.number }} {{ scope.row.unit }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="userInfo.vip_status == 1" prop="user_price" label="总价(元)">
            <template slot-scope="scope">
              <span>{{ scope.row.user_price }}</span>
            </template>
          </el-table-column>
          <el-table-column v-else prop="custorm_price" label="总价(元)">
            <template slot-scope="scope">
              <span>{{ scope.row.custorm_price }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="purity" label="纯度">
            <template slot-scope="scope">
              <span>{{ scope.row.purity }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="is_quote" label="现货">
            <template slot-scope="scope">
              <span>{{ scope.row.is_quote == 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stock_day" label="备货天数">
            <template slot-scope="scope">
              <span>{{ scope.row.stock_day }}天</span>
            </template>
          </el-table-column>
          <el-table-column prop="invoice_type" label="开票类型" width="100">
            <template slot-scope="scope">
                <span>{{
                    scope.row.invoice_type == 1 ? "专票(13%)" : "普票"
                  }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" v-if="userInfo.vip_status != 1" >
            <template slot-scope="scope">
              <el-button type="text" size="mini" v-if="!scope.row.is_buy" @click="handleBuy(scope.row)">立即购买
              </el-button>
              <el-button type="text" style="color: red" v-else size="mini">已购买</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-empty v-else description="暂无报价"/>
      </div>
    </div>
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               title="联系业务" :modal="false" top="20vh" :visible.sync="dialogVisible" width="30%"
               :before-close="handleClose">
      <span class="dialog-content" @click="copyText(dialogContent)">{{ dialogContent }} <i
          class="el-icon-copy-document"></i>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>

</template>
<script>

import {
  getMyCustomerService,
  purchaseDetail,
  quote_list_api,
} from "@/api/modules/user";
import {mapGetters} from 'vuex'

export default {
  props: {
    detailVisible: {
      type: Boolean,
      default: false,
    },
    dataInfo: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      detail: {},
      cas_no_quoteList: [],
      loading: true,
      customerInfo: {},
      dialogVisible: false,
      dialogContent: '',
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
    dataInfo(newValue) {
      if (newValue) {
        this.init()
      }
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible=false
    },
    contactBusiness() {
      this.dialogContent = `${this.customerInfo.name} ${this.customerInfo.mobile}`
      this.dialogVisible = true
    },
    getVip(row) {
       this.$router.push({path: '/vip/vip'})
    },
    init() {
      this.loading = true
      purchaseDetail(this.dataInfo.id).then((res) => {
        if (res.data.code == 10000) {
          this.detail = res.data.data;
          this.loading = false
        }
      });
      quote_list_api(this.dataInfo.id).then((res) => {
        if (res.data.code == 10000) {
          this.cas_no_quoteList = res.data.data.data;
        }
      });
      getMyCustomerService().then((res) => {
        if (res.data.code == 10000) {
          this.customerInfo = res.data.data.yewu;
        }
      });
    },
    handleBuy(row) {
      this.$router.push({
        path: "/user/purchase/bay",
        query: {id: row.id},
      });
    },
    detailClose() {
      this.$emit('updateStatus', false);
    }
  }
}
</script>

<style scoped lang="scss">
.color-red {
  color: red;
  display: inline-block;
  margin-left: 10px;
}

.tableDesc {
  display: flex;
  justify-content: space-between;
}

.add-box-account {

  .table-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;

    .title-text {
      font-weight: 500;
      font-size: 18px;
      color: #00112b;
      line-height: 25px;
      margin: 20px 0 10px;
    }
  }


  .vip-tag {
    margin-left: 10px;
    width: 50px;
    vertical-align: middle;
  }
}


.custom-table {
  width: 100%;
  border-collapse: collapse;
  /* 关键：合并边框 */
  border-color: #f3f3f3;

  /* 新增样式规则 */
  td:nth-child(1),
  td:nth-child(3) {
    width: 100px;
    padding: 10px 0;
    background: #f9faff;
    text-align: center;
    // line-height: 40px;
    color: #5f616c;
  }

  td:nth-child(2),
  td:nth-child(4) {
    padding: 10px 0;
    text-align: center;
    border: 1px solid #f3f3f3;
    color: #00112b;
  }
}

.table-box {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .img-box {
    height: 160px;
    width: 220px;
    margin-right: 20px;

    img {
      width: 220px;
      height: 120px;
      object-fit: contain;
    }
  }
}

@media (max-width: 360px) {
  .table-box {
    flex-direction: column;

    .img-box {
      width: 100%;
      margin-right: 0;
      margin-bottom: 15px;

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  .custom-table {

    td:nth-child(1),
    td:nth-child(3) {
      width: 80px;
      font-size: 12px;
    }

    td:nth-child(2),
    td:nth-child(4) {
      font-size: 12px;
    }
  }
}
</style>
